import React from 'react'
import Cleave from 'cleave.js/react'

function SSNField(field) {
  return (
    <Cleave
      options={{
        blocks: [4],
        numericOnly: true
      }}
      value={field.value}
      name={field.name}
      onChange={e => {
        field.onChange(e)
      }}
      onBlur={e => field.onBlur(e)}
      className="form__input"
      type="password"
      autoComplete="on"
      id="last_4_of_ssn"
      required
    />
  )
}

export default SSNField
